//Dev
// const PUBLIC_URL_IMG = 'http://localhost:5174/websiteadminqas/'

//Prod
const PUBLIC_URL_IMG = 'https://savings-cooperative.thaioilgroup.com/websiteadmin/';

//Qas
// const PUBLIC_URL_IMG = 'https://savings-cooperative.thaioilgroup.com/websiteadminqas/';

export default PUBLIC_URL_IMG;